import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classnames from 'classnames';
import { ParticipantsGridToggle, ParticipantsGridContent } from './index';
import { toggleGridView } from '../../../actions';
import { getGridViewOpenState } from '../../../selectors';
import './ParticipantsGrid.scss';
const ParticipantsGrid = ({ participants, selfParticipant }) => {
    const dispatch = useDispatch();
    const isOpen = useSelector(getGridViewOpenState);
    const setOpenState = useCallback(() => dispatch(toggleGridView()), []);
    const containerClassNames = classnames({
        'ml-grid': true,
        'ml-grid--hidden': !isOpen,
    });
    return (<div className={containerClassNames}>
      <div className="ml-grid__header">
        <ParticipantsGridToggle isOpen={isOpen} clickHandle={setOpenState}/>
      </div>
      <div className="ml-grid__content">
        <ParticipantsGridContent participants={participants} selfParticipant={selfParticipant}/>
      </div>
    </div>);
};
export default ParticipantsGrid;
